import { initializeCommandingViewModeInternal } from '../mutators/initializeCommandingViewModeInternal';
import { onViewModeInitialized } from '../actions/onViewModeInitialized';

export function initializeCommandingViewMode(primeBootSettingsOptions: any[]) {
    initializeCommandingViewModeInternal(primeBootSettingsOptions);
    onViewModeInitialized();
}
